import { SvgIcon } from '@mui/material';
import SvgApps from '../assets/icons/apps.svg.js';
import SvgArchive from '../assets/icons/archive.svg.js';
import SvgArrowDownSmall from '../assets/icons/arrow-down-small.svg.js';
import SvgArrowDown from '../assets/icons/arrow-down.svg.js';
import SvgArrowLeftSmall from '../assets/icons/arrow-left-small.svg.js';
import SvgArrowLeft from '../assets/icons/arrow-left.svg.js';
import SvgArrowRateHighest from '../assets/icons/arrow-rate-highest.svg.js';
import SvgArrowRateLowest from '../assets/icons/arrow-rate-lowest.svg.js';
import SvgArrowRightSmall from '../assets/icons/arrow-right-small.svg.js';
import SvgArrowRight from '../assets/icons/arrow-right.svg.js';
import SvgArrowTurnDownLeft from '../assets/icons/arrow-turn-down-left.svg.js';
import SvgArrowTurnDownRight from '../assets/icons/arrow-turn-down-right.svg.js';
import SvgArrowTurnUpLeft from '../assets/icons/arrow-turn-up-left.svg.js';
import SvgArrowTurnUpRight from '../assets/icons/arrow-turn-up-right.svg.js';
import SvgArrowUpSmall from '../assets/icons/arrow-up-small.svg.js';
import SvgArrowUp from '../assets/icons/arrow-up.svg.js';
import SvgBadgeFilled from '../assets/icons/badge-filled.svg.js';
import SvgBadgeOutline from '../assets/icons/badge-outline.svg.js';
import SvgBluetooth from '../assets/icons/bluetooth.svg.js';
import SvgBookingPrepare from '../assets/icons/booking-prepare.svg.js';
import SvgBookingReady from '../assets/icons/booking-ready.svg.js';
import SvgBooking from '../assets/icons/booking.svg.js';
import SvgBug from '../assets/icons/bug.svg.js';
import SvgCalendar from '../assets/icons/calendar.svg.js';
import SvgCartAdd from '../assets/icons/cart-add.svg.js';
import SvgCartAltAdd from '../assets/icons/cart-alt-add.svg.js';
import SvgCartAltDown from '../assets/icons/cart-alt-down.svg.js';
import SvgCartAltRemove from '../assets/icons/cart-alt-remove.svg.js';
import SvgCartAltUp from '../assets/icons/cart-alt-up.svg.js';
import SvgCartAlt from '../assets/icons/cart-alt.svg.js';
import SvgCartDown from '../assets/icons/cart-down.svg.js';
import SvgCartRemove from '../assets/icons/cart-remove.svg.js';
import SvgCartUp from '../assets/icons/cart-up.svg.js';
import SvgCart from '../assets/icons/cart.svg.js';
import SvgCashDrawer from '../assets/icons/cash-drawer.svg.js';
import SvgCheck from '../assets/icons/check.svg.js';
import SvgCheckboxFilled from '../assets/icons/checkbox-filled.svg.js';
import SvgCheckboxOutline from '../assets/icons/checkbox-outline.svg.js';
import SvgCheckboxPartial from '../assets/icons/checkbox-partial.svg.js';
import SvgChevronDown from '../assets/icons/chevron-down.svg.js';
import SvgChevronLeft from '../assets/icons/chevron-left.svg.js';
import SvgChevronRight from '../assets/icons/chevron-right.svg.js';
import SvgChevronSmallDown from '../assets/icons/chevron-small-down.svg.js';
import SvgChevronSmallLeft from '../assets/icons/chevron-small-left.svg.js';
import SvgChevronSmallRight from '../assets/icons/chevron-small-right.svg.js';
import SvgChevronSmallUp from '../assets/icons/chevron-small-up.svg.js';
import SvgChevronUp from '../assets/icons/chevron-up.svg.js';
import SvgClock from '../assets/icons/clock.svg.js';
import SvgClose from '../assets/icons/close.svg.js';
import SvgClothingDress from '../assets/icons/clothing-dress.svg.js';
import SvgClothingPants from '../assets/icons/clothing-pants.svg.js';
import SvgClothingShirt from '../assets/icons/clothing-shirt.svg.js';
import SvgCloudDown from '../assets/icons/cloud-down.svg.js';
import SvgCloudSearch from '../assets/icons/cloud-search.svg.js';
import SvgCloudUp from '../assets/icons/cloud-up.svg.js';
import SvgCloud from '../assets/icons/cloud.svg.js';
import SvgConnection from '../assets/icons/connection.svg.js';
import SvgCurrencyDenominations from '../assets/icons/currency-denominations.svg.js';
import SvgCurrencySwitch from '../assets/icons/currency-switch.svg.js';
import SvgDashboard from '../assets/icons/dashboard.svg.js';
import SvgDelete from '../assets/icons/delete.svg.js';
import SvgDeliveryArrowDown from '../assets/icons/delivery-arrow-down.svg.js';
import SvgDeliveryArrowUp from '../assets/icons/delivery-arrow-up.svg.js';
import SvgDeliveryPrepare from '../assets/icons/delivery-prepare.svg.js';
import SvgDeliveryReady from '../assets/icons/delivery-ready.svg.js';
import SvgDeliveryWarning from '../assets/icons/delivery-warning.svg.js';
import SvgDelivery from '../assets/icons/delivery.svg.js';
import SvgDepositFromBank from '../assets/icons/deposit-from-bank.svg.js';
import SvgDeposit from '../assets/icons/deposit.svg.js';
import SvgDisableSmall from '../assets/icons/disable-small.svg.js';
import SvgDisable from '../assets/icons/disable.svg.js';
import SvgDiscount from '../assets/icons/discount.svg.js';
import SvgDocumentation from '../assets/icons/documentation.svg.js';
import SvgDone from '../assets/icons/done.svg.js';
import SvgDownload from '../assets/icons/download.svg.js';
import SvgDragHandle from '../assets/icons/drag-handle.svg.js';
import SvgDuplicate from '../assets/icons/duplicate.svg.js';
import SvgEditSmall from '../assets/icons/edit-small.svg.js';
import SvgEdit from '../assets/icons/edit.svg.js';
import SvgEmail from '../assets/icons/email.svg.js';
import SvgEnter from '../assets/icons/enter.svg.js';
import SvgError from '../assets/icons/error.svg.js';
import SvgExchange from '../assets/icons/exchange.svg.js';
import SvgExit from '../assets/icons/exit.svg.js';
import SvgExport from '../assets/icons/export.svg.js';
import SvgExternalSmall from '../assets/icons/external-small.svg.js';
import SvgExternal from '../assets/icons/external.svg.js';
import SvgEyeSlash from '../assets/icons/eye-slash.svg.js';
import SvgEye from '../assets/icons/eye.svg.js';
import SvgFilterAsc from '../assets/icons/filter-asc.svg.js';
import SvgFilterDesc from '../assets/icons/filter-desc.svg.js';
import SvgFilter from '../assets/icons/filter.svg.js';
import SvgFlashOn from '../assets/icons/flash-on.svg.js';
import SvgFolderAdd from '../assets/icons/folder-add.svg.js';
import SvgFolderRemove from '../assets/icons/folder-remove.svg.js';
import SvgFolder from '../assets/icons/folder.svg.js';
import SvgGallery from '../assets/icons/gallery.svg.js';
import SvgGiftcard from '../assets/icons/giftcard.svg.js';
import SvgHandArrowDown from '../assets/icons/hand-arrow-down.svg.js';
import SvgHandArrowUp from '../assets/icons/hand-arrow-up.svg.js';
import SvgHome from '../assets/icons/home.svg.js';
import SvgImport from '../assets/icons/import.svg.js';
import SvgInfo from '../assets/icons/info.svg.js';
import SvgJournal from '../assets/icons/journal.svg.js';
import SvgLink from '../assets/icons/link.svg.js';
import SvgLockOpen from '../assets/icons/lock-open.svg.js';
import SvgLockSmallOpen from '../assets/icons/lock-small-open.svg.js';
import SvgLockSmall from '../assets/icons/lock-small.svg.js';
import SvgLock from '../assets/icons/lock.svg.js';
import SvgLogOut from '../assets/icons/log-out.svg.js';
import SvgManualIn from '../assets/icons/manual-in.svg.js';
import SvgManualOut from '../assets/icons/manual-out.svg.js';
import SvgMenu from '../assets/icons/menu.svg.js';
import SvgMinus from '../assets/icons/minus.svg.js';
import SvgMoreHorizontal from '../assets/icons/more-horizontal.svg.js';
import SvgMoreVertical from '../assets/icons/more-vertical.svg.js';
import SvgMove from '../assets/icons/move.svg.js';
import SvgNotificationAlert from '../assets/icons/notification-alert.svg.js';
import SvgNotification from '../assets/icons/notification.svg.js';
import SvgOrderAdd from '../assets/icons/order-add.svg.js';
import SvgOrderFulfilled from '../assets/icons/order-fulfilled.svg.js';
import SvgOrderRemove from '../assets/icons/order-remove.svg.js';
import SvgOrder from '../assets/icons/order.svg.js';
import SvgOrdersIncoming from '../assets/icons/orders-incoming.svg.js';
import SvgOrdersOutgoing from '../assets/icons/orders-outgoing.svg.js';
import SvgOrders from '../assets/icons/orders.svg.js';
import SvgPackageAdd from '../assets/icons/package-add.svg.js';
import SvgPackageArrowDown from '../assets/icons/package-arrow-down.svg.js';
import SvgPackageArrowUp from '../assets/icons/package-arrow-up.svg.js';
import SvgPackageRemove from '../assets/icons/package-remove.svg.js';
import SvgPackageWarning from '../assets/icons/package-warning.svg.js';
import SvgPackage from '../assets/icons/package.svg.js';
import SvgPaymentCash from '../assets/icons/payment-cash.svg.js';
import SvgPaymentCreditCard from '../assets/icons/payment-credit-card.svg.js';
import SvgPaymentCustom from '../assets/icons/payment-custom.svg.js';
import SvgPaymentGiftcard from '../assets/icons/payment-giftcard.svg.js';
import SvgPaymentUnknown from '../assets/icons/payment-unknown.svg.js';
import SvgPhoneMobile from '../assets/icons/phone-mobile.svg.js';
import SvgPhone from '../assets/icons/phone.svg.js';
import SvgPickupArrowDown from '../assets/icons/pickup-arrow-down.svg.js';
import SvgPickupArrowUp from '../assets/icons/pickup-arrow-up.svg.js';
import SvgPickupPrepacked from '../assets/icons/pickup-prepacked.svg.js';
import SvgPickupPrepare from '../assets/icons/pickup-prepare.svg.js';
import SvgPickupReady from '../assets/icons/pickup-ready.svg.js';
import SvgPickupWarning from '../assets/icons/pickup-warning.svg.js';
import SvgPickup from '../assets/icons/pickup.svg.js';
import SvgPin from '../assets/icons/pin.svg.js';
import SvgPlus from '../assets/icons/plus.svg.js';
import SvgPracticeMode from '../assets/icons/practice-mode.svg.js';
import SvgPrimitiveCircleHollowSmall from '../assets/icons/primitive-circle-hollow-small.svg.js';
import SvgPrimitiveCircleHollow from '../assets/icons/primitive-circle-hollow.svg.js';
import SvgPrimitiveCircleSmall from '../assets/icons/primitive-circle-small.svg.js';
import SvgPrimitiveCircle from '../assets/icons/primitive-circle.svg.js';
import SvgPrimitiveSquareRoundedSmall from '../assets/icons/primitive-square-rounded-small.svg.js';
import SvgPrimitiveSquareRounded from '../assets/icons/primitive-square-rounded.svg.js';
import SvgPrimitiveSquareSmall from '../assets/icons/primitive-square-small.svg.js';
import SvgPrimitiveSquare from '../assets/icons/primitive-square.svg.js';
import SvgPrint from '../assets/icons/print.svg.js';
import SvgProductGrid from '../assets/icons/product-grid.svg.js';
import SvgProgressDone from '../assets/icons/progress-done.svg.js';
import SvgProgressHalf from '../assets/icons/progress-half.svg.js';
import SvgProgressNone from '../assets/icons/progress-none.svg.js';
import SvgQuestion from '../assets/icons/question.svg.js';
import SvgRadioOff from '../assets/icons/radio-off.svg.js';
import SvgRadioOn from '../assets/icons/radio-on.svg.js';
import SvgReadyCheck from '../assets/icons/ready-check.svg.js';
import SvgReceiptPaid from '../assets/icons/receipt-paid.svg.js';
import SvgReceipt from '../assets/icons/receipt.svg.js';
import SvgRegisterCash from '../assets/icons/register-cash.svg.js';
import SvgRegisterClose from '../assets/icons/register-close.svg.js';
import SvgRegisterOpen from '../assets/icons/register-open.svg.js';
import SvgReload from '../assets/icons/reload.svg.js';
import SvgReportAdd from '../assets/icons/report-add.svg.js';
import SvgReportRemove from '../assets/icons/report-remove.svg.js';
import SvgReport from '../assets/icons/report.svg.js';
import SvgRetry from '../assets/icons/retry.svg.js';
import SvgReturn from '../assets/icons/return.svg.js';
import SvgReward from '../assets/icons/reward.svg.js';
import SvgRfidScan from '../assets/icons/rfid-scan.svg.js';
import SvgSalesTax from '../assets/icons/sales-tax.svg.js';
import SvgScanAdd from '../assets/icons/scan-add.svg.js';
import SvgScanOff from '../assets/icons/scan-off.svg.js';
import SvgScanOn from '../assets/icons/scan-on.svg.js';
import SvgScanRemove from '../assets/icons/scan-remove.svg.js';
import SvgScannerStatus from '../assets/icons/scanner-status.svg.js';
import SvgSearch from '../assets/icons/search.svg.js';
import SvgServiceOrders from '../assets/icons/service-orders.svg.js';
import SvgSettings from '../assets/icons/settings.svg.js';
import SvgShareAndroid from '../assets/icons/share-android.svg.js';
import SvgShareIos from '../assets/icons/share-ios.svg.js';
import SvgShipmentAdd from '../assets/icons/shipment-add.svg.js';
import SvgShipmentError from '../assets/icons/shipment-error.svg.js';
import SvgShipmentInbound from '../assets/icons/shipment-inbound.svg.js';
import SvgShipmentOutgoing from '../assets/icons/shipment-outgoing.svg.js';
import SvgShipmentRecieved from '../assets/icons/shipment-recieved.svg.js';
import SvgShipmentRemove from '../assets/icons/shipment-remove.svg.js';
import SvgShipment from '../assets/icons/shipment.svg.js';
import SvgShipments from '../assets/icons/shipments.svg.js';
import SvgShowCard from '../assets/icons/show-card.svg.js';
import SvgSitoo from '../assets/icons/sitoo.svg.js';
import SvgSort from '../assets/icons/sort.svg.js';
import SvgSpinner from '../assets/icons/spinner.svg.js';
import SvgStarFull from '../assets/icons/star-full.svg.js';
import SvgStarHalf from '../assets/icons/star-half.svg.js';
import SvgStar from '../assets/icons/star.svg.js';
import SvgStocktaking from '../assets/icons/stocktaking.svg.js';
import SvgStoreAdd from '../assets/icons/store-add.svg.js';
import SvgStoreApprove from '../assets/icons/store-approve.svg.js';
import SvgStoreCancel from '../assets/icons/store-cancel.svg.js';
import SvgStoreExport from '../assets/icons/store-export.svg.js';
import SvgStoreImport from '../assets/icons/store-import.svg.js';
import SvgStoreRemove from '../assets/icons/store-remove.svg.js';
import SvgStore from '../assets/icons/store.svg.js';
import SvgTaxFree from '../assets/icons/tax-free.svg.js';
import SvgTerminal from '../assets/icons/terminal.svg.js';
import SvgUndo from '../assets/icons/undo.svg.js';
import SvgUpload from '../assets/icons/upload.svg.js';
import SvgUsbAlt from '../assets/icons/usb-alt.svg.js';
import SvgUsb from '../assets/icons/usb.svg.js';
import SvgUserAdd from '../assets/icons/user-add.svg.js';
import SvgUserAlert from '../assets/icons/user-alert.svg.js';
import SvgUserDefault from '../assets/icons/user-default.svg.js';
import SvgUserRemove from '../assets/icons/user-remove.svg.js';
import SvgVariants from '../assets/icons/variants.svg.js';
import SvgWarehouseAdd from '../assets/icons/warehouse-add.svg.js';
import SvgWarehouseRemove from '../assets/icons/warehouse-remove.svg.js';
import SvgWarehouseSync from '../assets/icons/warehouse-sync.svg.js';
import SvgWarehouse from '../assets/icons/warehouse.svg.js';
import SvgWarning from '../assets/icons/warning.svg.js';
import SvgWithdrawalToBank from '../assets/icons/withdrawal-to-bank.svg.js';
import SvgWithdrawal from '../assets/icons/withdrawal.svg.js';
import SvgZoomIn from '../assets/icons/zoom-in.svg.js';
import SvgZoomOut from '../assets/icons/zoom-out.svg.js';
import { jsx } from 'react/jsx-runtime';

const AppsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgApps
});
const ArchiveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArchive
});
const ArrowDownSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowDownSmall
});
const ArrowDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowDown
});
const ArrowLeftSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowLeftSmall
});
const ArrowLeftIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowLeft
});
const ArrowRateHighestIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowRateHighest
});
const ArrowRateLowestIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowRateLowest
});
const ArrowRightSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowRightSmall
});
const ArrowRightIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowRight
});
const ArrowTurnDownLeftIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowTurnDownLeft
});
const ArrowTurnDownRightIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowTurnDownRight
});
const ArrowTurnUpLeftIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowTurnUpLeft
});
const ArrowTurnUpRightIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowTurnUpRight
});
const ArrowUpSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowUpSmall
});
const ArrowUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgArrowUp
});
const BadgeFilledIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgBadgeFilled
});
const BadgeOutlineIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgBadgeOutline
});
const BluetoothIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgBluetooth
});
const BookingPrepareIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgBookingPrepare
});
const BookingReadyIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgBookingReady
});
const BookingIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgBooking
});
const BugIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgBug
});
const CalendarIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCalendar
});
const CartAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartAdd
});
const CartAltAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartAltAdd
});
const CartAltDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartAltDown
});
const CartAltRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartAltRemove
});
const CartAltUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartAltUp
});
const CartAltIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartAlt
});
const CartDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartDown
});
const CartRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartRemove
});
const CartUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCartUp
});
const CartIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCart
});
const CashDrawerIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCashDrawer
});
const CheckIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCheck
});
const CheckboxFilledIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCheckboxFilled
});
const CheckboxOutlineIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCheckboxOutline
});
const CheckboxPartialIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCheckboxPartial
});
const ChevronDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgChevronDown
});
const ChevronLeftIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgChevronLeft
});
const ChevronRightIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgChevronRight
});
const ChevronSmallDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgChevronSmallDown
});
const ChevronSmallLeftIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgChevronSmallLeft
});
const ChevronSmallRightIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgChevronSmallRight
});
const ChevronSmallUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgChevronSmallUp
});
const ChevronUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgChevronUp
});
const ClockIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgClock
});
const CloseIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgClose
});
const ClothingDressIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgClothingDress
});
const ClothingPantsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgClothingPants
});
const ClothingShirtIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgClothingShirt
});
const CloudDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCloudDown
});
const CloudSearchIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCloudSearch
});
const CloudUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCloudUp
});
const CloudIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCloud
});
const ConnectionIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgConnection
});
const CurrencyDenominationsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCurrencyDenominations
});
const CurrencySwitchIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgCurrencySwitch
});
const DashboardIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDashboard
});
const DeleteIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDelete
});
const DeliveryArrowDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDeliveryArrowDown
});
const DeliveryArrowUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDeliveryArrowUp
});
const DeliveryPrepareIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDeliveryPrepare
});
const DeliveryReadyIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDeliveryReady
});
const DeliveryWarningIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDeliveryWarning
});
const DeliveryIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDelivery
});
const DepositFromBankIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDepositFromBank
});
const DepositIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDeposit
});
const DisableSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDisableSmall
});
const DisableIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDisable
});
const DiscountIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDiscount
});
const DocumentationIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDocumentation
});
const DoneIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDone
});
const DownloadIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDownload
});
const DragHandleIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDragHandle
});
const DuplicateIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgDuplicate
});
const EditSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgEditSmall
});
const EditIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgEdit
});
const EmailIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgEmail
});
const EnterIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgEnter
});
const ErrorIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgError
});
const ExchangeIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgExchange
});
const ExitIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgExit
});
const ExportIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgExport
});
const ExternalSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgExternalSmall
});
const ExternalIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgExternal
});
const EyeSlashIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgEyeSlash
});
const EyeIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgEye
});
const FilterAscIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgFilterAsc
});
const FilterDescIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgFilterDesc
});
const FilterIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgFilter
});
const FlashOnIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgFlashOn
});
const FolderAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgFolderAdd
});
const FolderRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgFolderRemove
});
const FolderIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgFolder
});
const GalleryIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgGallery
});
const GiftcardIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgGiftcard
});
const HandArrowDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgHandArrowDown
});
const HandArrowUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgHandArrowUp
});
const HomeIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgHome
});
const ImportIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgImport
});
const InfoIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgInfo
});
const JournalIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgJournal
});
const LinkIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgLink
});
const LockOpenIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgLockOpen
});
const LockSmallOpenIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgLockSmallOpen
});
const LockSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgLockSmall
});
const LockIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgLock
});
const LogOutIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgLogOut
});
const ManualInIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgManualIn
});
const ManualOutIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgManualOut
});
const MenuIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgMenu
});
const MinusIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgMinus
});
const MoreHorizontalIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgMoreHorizontal
});
const MoreVerticalIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgMoreVertical
});
const MoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgMove
});
const NotificationAlertIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgNotificationAlert
});
const NotificationIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgNotification
});
const OrderAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgOrderAdd
});
const OrderFulfilledIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgOrderFulfilled
});
const OrderRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgOrderRemove
});
const OrderIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgOrder
});
const OrdersIncomingIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgOrdersIncoming
});
const OrdersOutgoingIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgOrdersOutgoing
});
const OrdersIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgOrders
});
const PackageAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPackageAdd
});
const PackageArrowDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPackageArrowDown
});
const PackageArrowUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPackageArrowUp
});
const PackageRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPackageRemove
});
const PackageWarningIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPackageWarning
});
const PackageIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPackage
});
const PaymentCashIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPaymentCash
});
const PaymentCreditCardIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPaymentCreditCard
});
const PaymentCustomIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPaymentCustom
});
const PaymentGiftcardIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPaymentGiftcard
});
const PaymentUnknownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPaymentUnknown
});
const PhoneMobileIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPhoneMobile
});
const PhoneIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPhone
});
const PickupArrowDownIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPickupArrowDown
});
const PickupArrowUpIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPickupArrowUp
});
const PickupPrepackedIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPickupPrepacked
});
const PickupPrepareIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPickupPrepare
});
const PickupReadyIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPickupReady
});
const PickupWarningIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPickupWarning
});
const PickupIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPickup
});
const PinIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPin
});
const PlusIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPlus
});
const PracticeModeIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPracticeMode
});
const PrimitiveCircleHollowSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrimitiveCircleHollowSmall
});
const PrimitiveCircleHollowIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrimitiveCircleHollow
});
const PrimitiveCircleSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrimitiveCircleSmall
});
const PrimitiveCircleIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrimitiveCircle
});
const PrimitiveSquareRoundedSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrimitiveSquareRoundedSmall
});
const PrimitiveSquareRoundedIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrimitiveSquareRounded
});
const PrimitiveSquareSmallIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrimitiveSquareSmall
});
const PrimitiveSquareIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrimitiveSquare
});
const PrintIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgPrint
});
const ProductGridIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgProductGrid
});
const ProgressDoneIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgProgressDone
});
const ProgressHalfIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgProgressHalf
});
const ProgressNoneIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgProgressNone
});
const QuestionIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgQuestion
});
const RadioOffIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgRadioOff
});
const RadioOnIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgRadioOn
});
const ReadyCheckIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReadyCheck
});
const ReceiptPaidIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReceiptPaid
});
const ReceiptIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReceipt
});
const RegisterCashIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgRegisterCash
});
const RegisterCloseIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgRegisterClose
});
const RegisterOpenIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgRegisterOpen
});
const ReloadIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReload
});
const ReportAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReportAdd
});
const ReportRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReportRemove
});
const ReportIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReport
});
const RetryIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgRetry
});
const ReturnIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReturn
});
const RewardIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgReward
});
const RfidScanIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgRfidScan
});
const SalesTaxIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSalesTax
});
const ScanAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgScanAdd
});
const ScanOffIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgScanOff
});
const ScanOnIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgScanOn
});
const ScanRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgScanRemove
});
const ScannerStatusIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgScannerStatus
});
const SearchIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSearch
});
const ServiceOrdersIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgServiceOrders
});
const SettingsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSettings
});
const ShareAndroidIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShareAndroid
});
const ShareIosIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShareIos
});
const ShipmentAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShipmentAdd
});
const ShipmentErrorIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShipmentError
});
const ShipmentInboundIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShipmentInbound
});
const ShipmentOutgoingIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShipmentOutgoing
});
const ShipmentRecievedIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShipmentRecieved
});
const ShipmentRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShipmentRemove
});
const ShipmentIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShipment
});
const ShipmentsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShipments
});
const ShowCardIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgShowCard
});
const SitooIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSitoo
});
const SortIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSort
});
const SpinnerIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgSpinner
});
const StarFullIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStarFull
});
const StarHalfIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStarHalf
});
const StarIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStar
});
const StocktakingIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStocktaking
});
const StoreAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStoreAdd
});
const StoreApproveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStoreApprove
});
const StoreCancelIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStoreCancel
});
const StoreExportIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStoreExport
});
const StoreImportIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStoreImport
});
const StoreRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStoreRemove
});
const StoreIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgStore
});
const TaxFreeIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgTaxFree
});
const TerminalIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgTerminal
});
const UndoIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgUndo
});
const UploadIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgUpload
});
const UsbAltIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgUsbAlt
});
const UsbIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgUsb
});
const UserAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgUserAdd
});
const UserAlertIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgUserAlert
});
const UserDefaultIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgUserDefault
});
const UserRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgUserRemove
});
const VariantsIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgVariants
});
const WarehouseAddIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgWarehouseAdd
});
const WarehouseRemoveIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgWarehouseRemove
});
const WarehouseSyncIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgWarehouseSync
});
const WarehouseIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgWarehouse
});
const WarningIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgWarning
});
const WithdrawalToBankIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgWithdrawalToBank
});
const WithdrawalIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgWithdrawal
});
const ZoomInIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgZoomIn
});
const ZoomOutIcon = props => /*#__PURE__*/jsx(SvgIcon, {
  ...props,
  component: SvgZoomOut
});

export { AppsIcon, ArchiveIcon, ArrowDownIcon, ArrowDownSmallIcon, ArrowLeftIcon, ArrowLeftSmallIcon, ArrowRateHighestIcon, ArrowRateLowestIcon, ArrowRightIcon, ArrowRightSmallIcon, ArrowTurnDownLeftIcon, ArrowTurnDownRightIcon, ArrowTurnUpLeftIcon, ArrowTurnUpRightIcon, ArrowUpIcon, ArrowUpSmallIcon, BadgeFilledIcon, BadgeOutlineIcon, BluetoothIcon, BookingIcon, BookingPrepareIcon, BookingReadyIcon, BugIcon, CalendarIcon, CartAddIcon, CartAltAddIcon, CartAltDownIcon, CartAltIcon, CartAltRemoveIcon, CartAltUpIcon, CartDownIcon, CartIcon, CartRemoveIcon, CartUpIcon, CashDrawerIcon, CheckIcon, CheckboxFilledIcon, CheckboxOutlineIcon, CheckboxPartialIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronSmallDownIcon, ChevronSmallLeftIcon, ChevronSmallRightIcon, ChevronSmallUpIcon, ChevronUpIcon, ClockIcon, CloseIcon, ClothingDressIcon, ClothingPantsIcon, ClothingShirtIcon, CloudDownIcon, CloudIcon, CloudSearchIcon, CloudUpIcon, ConnectionIcon, CurrencyDenominationsIcon, CurrencySwitchIcon, DashboardIcon, DeleteIcon, DeliveryArrowDownIcon, DeliveryArrowUpIcon, DeliveryIcon, DeliveryPrepareIcon, DeliveryReadyIcon, DeliveryWarningIcon, DepositFromBankIcon, DepositIcon, DisableIcon, DisableSmallIcon, DiscountIcon, DocumentationIcon, DoneIcon, DownloadIcon, DragHandleIcon, DuplicateIcon, EditIcon, EditSmallIcon, EmailIcon, EnterIcon, ErrorIcon, ExchangeIcon, ExitIcon, ExportIcon, ExternalIcon, ExternalSmallIcon, EyeIcon, EyeSlashIcon, FilterAscIcon, FilterDescIcon, FilterIcon, FlashOnIcon, FolderAddIcon, FolderIcon, FolderRemoveIcon, GalleryIcon, GiftcardIcon, HandArrowDownIcon, HandArrowUpIcon, HomeIcon, ImportIcon, InfoIcon, JournalIcon, LinkIcon, LockIcon, LockOpenIcon, LockSmallIcon, LockSmallOpenIcon, LogOutIcon, ManualInIcon, ManualOutIcon, MenuIcon, MinusIcon, MoreHorizontalIcon, MoreVerticalIcon, MoveIcon, NotificationAlertIcon, NotificationIcon, OrderAddIcon, OrderFulfilledIcon, OrderIcon, OrderRemoveIcon, OrdersIcon, OrdersIncomingIcon, OrdersOutgoingIcon, PackageAddIcon, PackageArrowDownIcon, PackageArrowUpIcon, PackageIcon, PackageRemoveIcon, PackageWarningIcon, PaymentCashIcon, PaymentCreditCardIcon, PaymentCustomIcon, PaymentGiftcardIcon, PaymentUnknownIcon, PhoneIcon, PhoneMobileIcon, PickupArrowDownIcon, PickupArrowUpIcon, PickupIcon, PickupPrepackedIcon, PickupPrepareIcon, PickupReadyIcon, PickupWarningIcon, PinIcon, PlusIcon, PracticeModeIcon, PrimitiveCircleHollowIcon, PrimitiveCircleHollowSmallIcon, PrimitiveCircleIcon, PrimitiveCircleSmallIcon, PrimitiveSquareIcon, PrimitiveSquareRoundedIcon, PrimitiveSquareRoundedSmallIcon, PrimitiveSquareSmallIcon, PrintIcon, ProductGridIcon, ProgressDoneIcon, ProgressHalfIcon, ProgressNoneIcon, QuestionIcon, RadioOffIcon, RadioOnIcon, ReadyCheckIcon, ReceiptIcon, ReceiptPaidIcon, RegisterCashIcon, RegisterCloseIcon, RegisterOpenIcon, ReloadIcon, ReportAddIcon, ReportIcon, ReportRemoveIcon, RetryIcon, ReturnIcon, RewardIcon, RfidScanIcon, SalesTaxIcon, ScanAddIcon, ScanOffIcon, ScanOnIcon, ScanRemoveIcon, ScannerStatusIcon, SearchIcon, ServiceOrdersIcon, SettingsIcon, ShareAndroidIcon, ShareIosIcon, ShipmentAddIcon, ShipmentErrorIcon, ShipmentIcon, ShipmentInboundIcon, ShipmentOutgoingIcon, ShipmentRecievedIcon, ShipmentRemoveIcon, ShipmentsIcon, ShowCardIcon, SitooIcon, SortIcon, SpinnerIcon, StarFullIcon, StarHalfIcon, StarIcon, StocktakingIcon, StoreAddIcon, StoreApproveIcon, StoreCancelIcon, StoreExportIcon, StoreIcon, StoreImportIcon, StoreRemoveIcon, TaxFreeIcon, TerminalIcon, UndoIcon, UploadIcon, UsbAltIcon, UsbIcon, UserAddIcon, UserAlertIcon, UserDefaultIcon, UserRemoveIcon, VariantsIcon, WarehouseAddIcon, WarehouseIcon, WarehouseRemoveIcon, WarehouseSyncIcon, WarningIcon, WithdrawalIcon, WithdrawalToBankIcon, ZoomInIcon, ZoomOutIcon };
